.container {
  display: grid;
  gap: 16px;

  @media screen and (width >= 769px) {
    gap: 48px;
  }
}

.heading {
  font-size: var(--font-size-xl);
  font-weight: 700;
  text-align: center;
}

.detail {
  display: grid;
  gap: 22px;
  font-size: var(--font-size-sm);

  @media screen and (width >= 769px) {
    padding-bottom: 22px;
  }

  span {
    display: block;
  }
}

.link {
  color: var(--color-text-link);

  &:hover {
    color: var(--color-text-link-hover);
    text-decoration: underline;
  }
}

.supplement {
  font-size: var(--font-size-xs);
}
